import React,{useEffect} from "react"


interface Props {
  overlay?: any
}

export default function Loading(props: Props) {
  const { overlay } = props

  // useEffect(() => {
  //   document.body.style.overflow = 'hidden';
  // }, [ ]);

  return <div>loading...</div>
}
